import {
  Fragment, useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  DatabaseOutlined,
  ToolOutlined,
  SafetyOutlined,
  RiseOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  register: <DatabaseOutlined />,
  maintain: <ToolOutlined />,
  inspect: <SafetyOutlined />,
  optimize: <RiseOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("eam");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-eam-workflow-grid",
        isCompact ? "dev-eam-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-eam-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-eam-step-item">
                <div className={`dev-eam-step-card dev-eam-step-card--${step.key}`}>
                  <div className="dev-eam-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-eam-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-eam-step-card dev-eam-step-card--${step.key}`}>
                <div className="dev-eam-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-eam-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-eam-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
